import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Camera, BookOpen } from 'lucide-react';
export const CreatorsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  const creators = [{
    name: 'Kanwar Singh Dhillon',
    role: 'Visual Artist',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qyiWpXgsTbQ8qffx5zoMhp/KanwarSingh.jpg',
    icon: <Camera className="w-5 h-5" data-id="element-979" data-mp="3a3z700jebzyp" />,
    description: 'Renowned for his Art of Punjab collection, bringing historical moments to life through vibrant, detailed artwork.',
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6TA9bnDgaF4queat9qTtnf/Screenshot_2025-10-08_at_10.47.29_PM.png'
  }, {
    name: 'Inkquisitive',
    role: 'Visual Artist',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPPtrXJSvzXxH8SA4Qh5Q6/Inkquisitive_Aman_looking_right.webp',
    icon: <Camera className="w-5 h-5" data-id="element-980" data-mp="1dfk8yqksa5c4" />,
    description: 'Global contemporary Sikh artist specializing in immersive digital experiences and cutting-edge projection mapping.',
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aNk557nof1kNhT4tzQY7ze/Screenshot_2025-10-08_at_10.48.47_PM.png'
  }, {
    name: 'Sarbpreet Singh',
    role: 'Story Consultant',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fjZT6BXdSgT5X1VfqK593T/sarbpreet_singh.jpg',
    icon: <BookOpen className="w-5 h-5" data-id="element-981" data-mp="fqqlwm01wd2r" />,
    description: 'Host of The Story of the Sikhs podcast, bringing historical narratives to life through authentic storytelling.',
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fTHgkCdqA3ZjhsQgSngNAE/story_of_sikhs_.jpg'
  }];
  return <motion.section id="creators" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-982" data-mp="2dfvtb19hnrja">
      <div className="container mx-auto px-4" data-id="element-983" data-mp="28nm6hu3o77l8">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-984" data-mp="23rdx6xc5m8lz">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-985" data-mp="2re3xnu8utv4h">
            Visionary Minds
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-986" data-mp="2ifiepxzh0e36">
            THE
            <br data-id="element-987" data-mp="1bywps73s4l0u" />
            <span className="text-amber-400" data-id="element-988" data-mp="1bzg8hq197dfx">CREATORS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-989" data-mp="1703aqa8uglyk"></div>
        </motion.div>
        {/* Award-winning teams */}
        <div className="mb-24 max-w-5xl mx-auto" data-id="element-990" data-mp="3io84fqibo383">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-991" data-mp="3ilc6w3adzgk6">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="border border-white/10 p-8" data-id="element-992" data-mp="3nnbb1fdyahi6">
              <div className="mb-6" data-id="element-993" data-mp="a5sk9n480we3">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bkLr1CMuqSBd6pu7RzMCxA/Screenshot_2025-10-08_at_9.49.05_PM.png" alt="Oscar Award" className="w-20 h-auto rounded-lg" data-id="element-994" data-mp="f6zs1m6d5vkr" />
              </div>
              <h4 className="text-xl font-serif text-white mb-3" data-id="element-995" data-mp="2kzol0cbk4gmw">
                Oscar-winning Animators
              </h4>
              <p className="text-white/60 font-light" data-id="element-996" data-mp="1poyr78as6sew">
                The team behind Lord of the Rings brings their mastery of visual
                storytelling to recreate the Sikh Kingdom's grandeur.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="border border-white/10 p-8" data-id="element-997" data-mp="1zmwentktgl6g">
              <div className="mb-6" data-id="element-998" data-mp="1bxtofxc49k0c">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iGtrqhEqCZgpged46uK4JA/Screenshot_2025-10-08_at_9.50.49_PM.png" alt="Emmy Award" className="w-20 h-auto rounded-lg" data-id="element-999" data-mp="1bwsczrr6uvi3" />
              </div>
              <h4 className="text-xl font-serif text-white mb-3" data-id="element-1000" data-mp="2uvzrjdrr4w33">
                Emmy-winning Artists
              </h4>
              <p className="text-white/60 font-light" data-id="element-1001" data-mp="2zosvw0jb62en">
                The creative minds behind Hasbro's global installations lend
                their expertise to craft immersive environments.
              </p>
            </motion.div>
          </div>
        </div>
        {/* Sikh Visionaries */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-24 max-w-6xl mx-auto" data-id="element-1002" data-mp="3do2e15r2r6l9">
          {creators.map((creator, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group" data-id="element-1003" data-mp="34mumr7mz760o" data-mpi={index}>
              <div className="flex items-start gap-6" data-id="element-1004" data-mp="3seh6xbkug5s">
                <div className="relative flex-shrink-0" data-id="element-1005" data-mp="3uxmq6i7j38fm">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-amber-400/30" data-id="element-1006" data-mp="3q5v8kx6cod1m">
                    <img src={creator.image} alt={creator.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-1007" data-mp="3m49r0yivfal3" />
                  </div>
                  <div className="absolute -bottom-2 -right-2 w-12 h-12 overflow-hidden border border-amber-400/50 rounded-lg bg-black" data-id="element-1008" data-mp="3c86mxn4gl1vi">
                    <img src={creator.thumbnail} alt={`${creator.name}'s work`} className="w-full h-full object-cover" data-id="element-1009" data-mp="335p29d4gcham" />
                  </div>
                </div>
                <div className="flex-1 pt-2" data-id="element-1010" data-mp="11eu105rh7pwi">
                  <div className="flex items-center mb-2" data-id="element-1011" data-mp="2jbxhl9b4choq">
                    <div className="text-amber-400 mr-2" data-id="element-1012" data-mp="2j9kzmw5d27bo">{creator.icon}</div>
                    <p className="text-amber-400/70 text-xs tracking-wider uppercase" data-id="element-1013" data-mp="2o9h1aoql5mo2">
                      {creator.role}
                    </p>
                  </div>
                  <h3 className="font-serif text-xl text-white mb-2" data-id="element-1014" data-mp="2x3by99hk06sm">
                    {creator.name}
                  </h3>
                  <p className="text-white/60 text-sm font-light leading-relaxed" data-id="element-1015" data-mp="20e4k4mj9kzyq">
                    {creator.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
        {/* Technology Partners */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-1016" data-mp="2ecujy9xgxdqs">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1017" data-mp="31d370my5rayv">
            <div className="border border-white/10 p-6 text-center" data-id="element-1018" data-mp="2whe1m2zgizun">
              <h3 className="text-amber-400 tracking-wider uppercase text-sm mb-4" data-id="element-1019" data-mp="3a811vzkv8xsu">
                Gen AI Studio
              </h3>
              <div className="flex justify-center mb-4" data-id="element-1020" data-mp="35fzizut708tu">
                <div className="w-20 h-20 rounded-lg overflow-hidden border border-amber-400/30" data-id="element-1021" data-mp="3k5f690tilw4s">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2dTJiTKCByJiT1M31ApAvv/image.png" alt="ATHINK AI Studio" className="w-full h-full object-cover" data-id="element-1022" data-mp="3f6ue7oof2irf" />
                </div>
              </div>
              <p className="text-white/60 text-xs font-light" data-id="element-1023" data-mp="1yscamw0kxcm8">
                Cutting-edge generative AI technology
              </p>
            </div>
            <div className="border border-white/10 p-6 text-center" data-id="element-1024" data-mp="1usbnmmzezt3k">
              <h3 className="text-amber-400 tracking-wider uppercase text-sm mb-4" data-id="element-1025" data-mp="1kmk55x487aa8">
                Producer
              </h3>
              <div className="flex justify-center mb-4" data-id="element-1026" data-mp="1onw08i5vcnpt">
                <div className="w-20 h-20 rounded-lg overflow-hidden border border-amber-400/30" data-id="element-1027" data-mp="1axisafsz990h">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfUmCGwV8VKNhoTqyFkwKd/secret_location.jpg" alt="Secret Location" className="w-full h-full object-cover" data-id="element-1028" data-mp="1fvk9swar909u" />
                </div>
              </div>
              <p className="text-white/60 text-xs font-light" data-id="element-1029" data-mp="ryobz2dv80i7">
                Award-winning production company
              </p>
            </div>
            <div className="border border-white/10 p-6 text-center" data-id="element-1030" data-mp="wxhrt1gmk3lj">
              <h3 className="text-amber-400 tracking-wider uppercase text-sm mb-4" data-id="element-1031" data-mp="2md7eh4yeq408">
                Beverage Curator
              </h3>
              <div className="flex justify-center mb-4" data-id="element-1032" data-mp="2rahaj3gaxdx1">
                <div className="w-24 h-20 overflow-hidden border border-amber-400/30 bg-white flex items-center justify-center rounded-lg" data-id="element-1033" data-mp="2odf490thad8t">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9rVcjFgryVT5M4PXCLffva/image.png" alt="Mystical Mocktails" className="w-full h-full object-contain p-2" data-id="element-1034" data-mp="2t6gjj9xlkesx" />
                </div>
              </div>
              <p className="text-white/60 text-xs font-light" data-id="element-1035" data-mp="37225174mgggl">
                Mystical Mocktails
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>;
};